module.exports = __webpack_public_path__ + "img/BI.2ff6cf3a.jpg";